<table class="my-info">
    <tbody class="myInfoBody">
    <tr>
        <td class="info-text" *ngIf="nationalityName">{{ nationalityName }}</td>
        <td class="info-text">{{ (myInfo?.rank | number) || '-' }}</td>
        <td class="info-text">{{ (myInfo?.point | number: (isBountyKOPromotion ? '1.0-0' : '1.2-2')) || '-' }}</td>
        <td *ngIf="prizeVisibility" class="info-text">
            <ng-template [ngIf]="!isChase" [ngIfElse]="chasePrize">
                <ng-template [ngIf]="!!myInfo && !!myInfo.prize" [ngIfElse]="nullPrize">
                    <ng-template [ngIf]="!!myInfo.prize.value" [ngIfElse]="customPrize">
                            <span *ngIf="!isWsopPrizeCustom">
                                {{ myInfo.prize.value | cash : myInfo.prize.currencyId:'symbol-narrow':'1.2-2': null: onlyCoin: hideSymbol: hideCustomSymbol }}
                            </span>
                        <span *ngIf="isWsopPrizeCustom">
                                {{ myInfo.prize.value | cash : myInfo.prize.currencyId:'symbol-narrow':'1.2-2': null: onlyCoin: hideSymbol: hideCustomSymbol }}
                            <span class="prizeItem"><br>{{ wsopPrizeCustom(myInfo.prize) }}</span>
                            </span>
                    </ng-template>
                    <ng-template #customPrize>{{ myInfo.prize.description || '-' }}</ng-template>
                </ng-template>
                <ng-template #nullPrize>-</ng-template>
            </ng-template>
            <ng-template #chasePrize>
                <ng-template [ngIf]="!!myInfo && !!myInfo.prize" [ngIfElse]="nullPrize">
                    <ng-template [ngIf]="!!myInfo.prizePaid.value" [ngIfElse]="customPrize">
                        {{ myInfo.prizePaid.value | cash : myInfo.prizePaid.currencyId:'symbol-narrow':'1.2-2': null: onlyCoin: hideSymbol: hideCustomSymbol }}
                    </ng-template>
                    <ng-template #customPrize>{{ !!myInfo.prize.description ? 'Custom' : '-' }}</ng-template>
                </ng-template>
                <ng-template #nullPrize>-</ng-template>
            </ng-template>
        </td>
    </tr>
    <tr>
        <td class="info-text-info" *ngIf="nationalityName">{{ 'My Continental' | translate }}</td>
        <td class="info-text-info">{{ 'myRank' | translate }}</td>
        <td class="info-text-info">{{ (isBountyKOPromotion ? 'myKOs' : 'myPoints') | translate }}</td>
        <td *ngIf="prizeVisibility" class="info-text-info">{{ 'myPrize' | translate }}</td>
    </tr>
    </tbody>
</table>
